<template>
  <v-container fluid>
    <div id="content">
      
      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <v-card flat>

        <v-sheet class="d-flex justify-space-between">
          <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
            <v-icon>fas fa-chevron-left</v-icon>
          </v-btn>
          <v-menu
            v-model="viewDate"
            :close-on-content-click="false"
            :nudge-right="0"
            transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on }">
              <v-btn text class="ma-2" v-on="on">
                {{ calendarTitle }}
              </v-btn>
            </template>
            <v-date-picker 
              v-model="calendar" 
              type="month"
              @change="dateFormat"
              @input="viewDate = false">
            </v-date-picker>
          </v-menu>
          <v-btn icon class="ma-2" @click="$refs.calendar.next()">
            <v-icon>fas fa-chevron-right</v-icon>
          </v-btn>
        </v-sheet>

        <v-sheet :height="calendarHeight">
          <v-calendar
            ref="calendar"
            v-model="calendar"
            :show-month-on-first="false"
            :day-format="timestamp => new Date(timestamp.date).getDate()"
            :month-format="timestamp => (new Date(timestamp.date).getMonth() + 1) + ' /'"
            :events="desserts"
            @change="viewChange"
            @mousedown:event="clickEvent"
            @mousedown:day="mouseStart"
            @mousemove:day="mouseMove"
            @mouseup:day="mouseEnd"
            @mouseleave.native="mouseCancel"
            @touchstart:event="touchEvent"
            @touchmove:event="touchMove"
            @touchstart:day="mouseStart"
            @touchmove:day="mouseMove"
            @touchend:day="mouseEnd">
          </v-calendar>
        </v-sheet>

      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog" class="edit-dialog">
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ $route.name }}を{{ this.editedIndex === -1 ? '追加' : '編集' }}</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <section class="accordion_inner">
                <v-row no-gutters>
                  <v-col cols="6" class="pa-2">
                    <v-menu
                      v-model="startDate"
                      :close-on-content-click="false"
                      :nudge-right="0"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          ref="startDate"
                          label="開始日付"
                          v-model="editedItem.start"
                          :rules="[rules.required]"
                          class="required"
                          v-on="on"
                          outlined hide-details="auto">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="editedItem.start" @input="startDate = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-menu
                      v-model="endDate"
                      :close-on-content-click="false"
                      :nudge-right="0"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          ref="endDate"
                          label="終了日付"
                          v-model="editedItem.end"
                          :rules="[rules.required]"
                          class="required"
                          v-on="on"
                          outlined hide-details="auto">
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="editedItem.end" @input="endDate = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" class="pa-2">
                    <v-text-field
                      ref="name"
                      label="名称"
                      v-model="editedItem.name"
                      outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-combobox
                      ref="type"
                      label="種別"
                      v-model="editedItem.type"
                      :items="types"
                      :rules="[rules.required]"
                      class="required"
                      append-icon="fas fa-list-ol"
                      @click.stop="openSelected('type', false)"
                      readonly outlined hide-details="auto">
                    </v-combobox>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-swatches v-model="editedItem.color">
                      <v-text-field
                        ref="color"
                        label="色"
                        slot="trigger"
                        :background-color="editedItem.color"
                        v-model="editedItem.color"
                        readonly outlined hide-details="auto">
                      </v-text-field>
                    </v-swatches>
                  </v-col>
                </v-row>
              </section>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" text x-large>
              <v-icon left>fas fa-save</v-icon>{{ this.editedIndex === -1 ? '登録' : '更新' }}
            </v-btn>
            <v-btn color="error" @click.stop="remove" :loading="saving" v-if="editedIndex > -1" text x-large>
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { createEvent, updateEvent, deleteEvent } from '../graphql/mutations'
import { listEvents } from '../graphql/queries'
import { 
  onCreateEvent, onUpdateEvent, onDeleteEvent } from '../graphql/subscriptions'
import moment from 'moment'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  data() {
    return {
      search: '',
      loading: true,
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      editedIndex: -1,
      editedItem: {},
      types: [
        { value: 1, text: '休日' },
        { value: 2, text: 'イベント' },
      ],
      calendar: moment().format('YYYY-MM-DD'),
      viewDate: false,
      startDate: false,
      endDate: false,
      editEvent: false,
      createEvent: null,
      createStart: null,
      hookFlg: false,
    }
  },
  prop: {},
  mounted: async function() {
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateEvent
        this.desserts.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateEvent
        this.desserts.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteEvent
        this.desserts = this.desserts.filter(origin => origin.id !== row.id)
      }
    })
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    form() {
      return {
        id: this.editedItem.id || null,
        start: this.editedItem.start || null,
        end: this.editedItem.end || null,
        name: this.editedItem.name || this.editedItem.type.text,
        type: this.editedItem.type ? this.editedItem.type.value : null,
        color: this.editedItem.color,
      }
    },
    //カレンダーのタイトル
    calendarTitle() {
      return moment(this.calendar).format('YYYY年 M月')
    },
    //カレンダーの高さ
    calendarHeight() {
      return window.innerHeight - 250
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    //初期化
    async init() {

    },
    //保存
    async save() {
      try {
        this.saving = true
        const data = this.form

        //編集
        if (data.id) {
          await API.graphql(graphqlOperation(updateEvent, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を更新しました' })
          this.myAlert(data.name + 'を更新しました', 'success')

        //新規
        } else {
          delete data.id
          await API.graphql(graphqlOperation(createEvent, {input: data}))
          this.log({ type: this.$route.name, text: '[' + data.name + '] を追加しました' })
          this.myAlert(data.name + 'を追加しました', 'success')
        }

        this.dialog = false

      } catch (e) {
        //console.log(e)
        this.myAlert(e)
        this.saving = false
      }
    },
    //削除
    async remove() {
      try {
        if (confirm(this.editedItem.name + 'を削除しますか？')) {
          //削除
          await API.graphql(graphqlOperation(deleteEvent, {
            input: { id: this.editedItem.id }
          }))
          this.log({ type: this.$route.name, text: '[' + this.editedItem.name + '] を削除しました' })
          this.myAlert(this.editedItem.name + 'を削除しました', 'success')
          this.dialog = false
        }

      } catch (error) {
        this.myAlert(error)
      }
    },
    //ダイアログclose
    close() {
      this.saving = false
      this.editEvent = false
      this.mouseCancel()
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //フォームreset
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        if (this.$refs[f] && !!this.$refs[f].reset) this.$refs[f].reset()
      })
      this.editedItem.id = null
    },
    //カレンダー表示日
    dateFormat() {
      this.calendar = moment(this.calendar).format('YYYY-MM-DD')
    },
    //イベントクリック
    clickEvent({ event }) {
      this.editEvent = true
      //イベントの編集ダイアログを表示
      const target = this.desserts.find(e => e.id === event.id)
      this.editedIndex = this.desserts.findIndex(e => e.id === event.id)
      this.editedItem = {
        id: target.id,
        name: target.name,
        start: target.start,
        end: target.end,
        type: target.type ? this.types.find(e => e.value == target.type) : null,
        color: target.color,
      }
      this.dialog = true
    },
    //イベントタッチ
    touchEvent(info) {
      this.editEvent = true
      setTimeout(function(path) {
        if (path.editEvent) path.clickEvent(info)
      }, 500, this)
    },
    //イベントタッチして移動
    touchMove() {
      this.editEvent = false
    },
    //日付タップ
    mouseStart(view) {
      if (!this.editEvent) {
        this.hookFlg = true
        setTimeout(function(path) {
          if (path.hookFlg) path.hookEvent(view)
        }, 500, this)
      }
    },
    //新しいイベント生成
    hookEvent(view) {
      this.createStart = view.date
      this.createEvent = {
        name: '選択中',
        start: this.createStart,
        end: this.createStart,
        type: this.types[0],
        color: '#E84B3C',
      }
      this.desserts.push(this.createEvent)
    },
    //日付ドラッグ中
    mouseMove(view) {
      this.hookFlg = false
      if (this.createEvent && this.createStart) {
        const min = Math.min(moment(view.date).unix(), moment(this.createStart).unix())
        const max = Math.max(moment(view.date).unix(), moment(this.createStart).unix())

        this.createEvent.start = moment.unix(min).format('YYYY-MM-DD')
        this.createEvent.end = moment.unix(max).format('YYYY-MM-DD')
      }
    },
    //タイムテーブル ドラッグ終了
    mouseEnd() {
      this.hookFlg = false
      if (this.createEvent && this.createStart) {
        //新しいイベントの登録ダイアログを表示
        this.editedItem = {
          name: null,
          start: moment(this.createEvent.start).format('YYYY-MM-DD'),
          end: moment(this.createEvent.end).format('YYYY-MM-DD'),
          type: this.types[0],
          color: '#E84B3C',
        }
        this.dialog = true
      }
    },
    //タイムテーブル ドラッグ範囲外
    mouseCancel() {
      if (this.dialog) return

      this.desserts = this.desserts.filter(e => e !== this.createEvent)

      this.createEvent = null
      this.createStart = null
    },
    //ビュー変更
    async viewChange({start, end}) {
      this.desserts = []
      const s = moment(start.date).subtract(7, 'days').format('YYYY-MM-DD')
      const e = moment(end.date).add(7, 'days').format('YYYY-MM-DD')
      await this.getEvents(s, e)
    },
    //イベントの取得
    async getEvents(start, end, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listEvents, {
        filter: {
          and: [
            { start: { ge: moment(start).subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss') } },
            { end: { le: moment(end).format('YYYY-MM-DDTHH:mm:ss') } },
          ],
        },
        limit: 500,
        nextToken: nextToken
      }))
      for (const data of query.data.listEvents.items) {
        this.desserts.push(data)
      }
      if (query.data.listEvents.nextToken) this.getEvents(start, end, query.data.listEvents.nextToken)
    },
  },
  components: {
    VSwatches,
  },
}
</script>

<style lang='scss' scoped>

</style>
